<template>
    <header class="w-full h-header bg-canvas border-b border-line-strong">
        <div class="page-container h-full flex items-center gap-8">
            <NuxtLink to="/" class="flex items-center gap-3">
                <!-- App icon from the desktop companion (src-tauri/icon.svg), drawn in the text color so it works in both themes. -->
                <svg viewBox="0 0 1024 1024" class="h-7 w-7" aria-hidden="true">
                    <path d="M512 116 L932 850 H92 Z" fill="none" stroke="currentColor" stroke-width="64" stroke-linejoin="round"/>
                    <path d="M430 440 L512 555 L594 440 M512 555 L512 625" fill="none" stroke="currentColor" stroke-width="64" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="512" cy="718" r="32" fill="currentColor"/>
                </svg>
                <span class="text-h3 font-bold">Error Platform</span>
            </NuxtLink>

            <template v-if="userStore.isLoggedIn()">
                <nav class="flex items-center gap-4">
                    <NuxtLink to="/" class="text-small font-semibold underline-offset-4 hover:underline">Dashboard</NuxtLink>
                    <NuxtLink to="/activity" class="text-small font-semibold underline-offset-4 hover:underline">Activity</NuxtLink>
                    <NuxtLink to="/notifications" class="text-small font-semibold underline-offset-4 hover:underline">Notifications</NuxtLink>
                    <DesktopMenu/>
                    <AdminMenu v-if="userStore.isAdmin()"/>
                </nav>

                <div class="ml-auto flex items-center gap-4">
                    <UserMenu/>
                    <YButton variant="secondary" size="sm" @click="logout">Log out</YButton>
                </div>
            </template>
        </div>
    </header>
</template>

<script lang="ts" setup>
const userStore = useUserStore()
const { logout } = useAuth()
</script>
